import { render, staticRenderFns } from "./delivery-area-edit.vue?vue&type=template&id=0fe8214f"
import script from "./delivery-area-edit.vue?vue&type=script&lang=js"
export * from "./delivery-area-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports